import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import heroDecorative1 from '../assets/careers/hero-decorative-1.jpg';
import heroDecorative2 from '../assets/careers/hero-decorative-2.jpg';

const CareersHeroSection: React.FC = () => {
  const navigate = useNavigate();

  const scrollToPositions = () => {
    const positionsSection = document.getElementById('open-positions');
    if (positionsSection) {
      positionsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative bg-white overflow-hidden" style={{ minHeight: '402px', paddingTop: '64px' }}>
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 relative" style={{ height: '402px' }}>
        {/* Decorative Image 1 - Top Left */}
        <div className="absolute left-0 top-0 w-[350px] h-[183px] overflow-hidden hidden lg:block">
          <img
            src={heroDecorative1}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>

        {/* Decorative Image 2 - Top Right */}
        <div className="absolute right-0 top-[181px] w-[231px] h-[221px] overflow-hidden hidden lg:block">
          <img
            src={heroDecorative2}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>

        {/* Main Content */}
        <div className="relative z-10 flex flex-col items-center justify-center h-full text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="font-open-sans font-bold text-[52px] leading-[74px] text-[#323743] mb-6"
            style={{ fontVariationSettings: "'wdth' 100" }}
          >
            Join our team
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="font-manrope font-normal text-[18px] leading-[28px] text-[#323743] max-w-[585px] mb-8"
          >
            Ex adipisicing sint occaecat tempor incididunt incididunt eu minim anim irure fugiat mi
          </motion.p>

          <motion.button
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            onClick={scrollToPositions}
            className="bg-brand-yellow text-[#704b00] font-manrope font-normal text-[18px] leading-[28px] px-8 py-3 rounded-lg hover:bg-brand-yellow-400 transition-colors"
            style={{ width: '263px', height: '52px' }}
          >
            View open positions
          </motion.button>
        </div>
      </div>
    </section>
  );
};

export default CareersHeroSection;
